<template>
    <generic-modal :show="show" @closing="show = false">
        <slot></slot>
    </generic-modal>
</template>

<script>
export default {
    data() {
        return {
            show: false
        }
    },

    mounted() {
        this.$event.$on('terms-modal:show', () => {
            this.show = true;
        });

        this.$event.$on('terms-modal:close', () => {
            this.show = false;
        });
    }
}
</script>
